import { createAsyncThunk } from '@reduxjs/toolkit';
import { GoogleMerchantSyncAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IGoogleMerchantFullSyncEnqueueDTO,
  IGoogleMerchantDeltaSyncEnqueueDTO,
  IGoogleMerchantProductSyncEnqueueDTO,
  IGoogleMerchantSyncEnqueueResponse,
  IGetGoogleMerchantSyncRunsDTO,
  IGetGoogleMerchantSyncRunsResponse,
} from '@/models/googleMerchantSync.model';
import { SLICE_NAME } from './models';

export const getGoogleMerchantSyncRuns = createAsyncThunk<
  IGetGoogleMerchantSyncRunsResponse,
  IGetGoogleMerchantSyncRunsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getGoogleMerchantSyncRuns`,
  async (params) => {
    const response = await GoogleMerchantSyncAPI.getSyncRuns(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const syncGoogleMerchantFull = createAsyncThunk<
  IGoogleMerchantSyncEnqueueResponse,
  IGoogleMerchantFullSyncEnqueueDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/syncGoogleMerchantFull`,
  async (data) => {
    const response = await GoogleMerchantSyncAPI.syncFull(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const syncGoogleMerchantDelta = createAsyncThunk<
  IGoogleMerchantSyncEnqueueResponse,
  IGoogleMerchantDeltaSyncEnqueueDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/syncGoogleMerchantDelta`,
  async (data) => {
    const response = await GoogleMerchantSyncAPI.syncDelta(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const syncGoogleMerchantProduct = createAsyncThunk<
  IGoogleMerchantSyncEnqueueResponse,
  IGoogleMerchantProductSyncEnqueueDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/syncGoogleMerchantProduct`,
  async (data) => {
    const response = await GoogleMerchantSyncAPI.syncProduct(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
